import React, { Fragment } from 'react'
import { Typography, Grid, Box, Link as A } from '@material-ui/core'
import { ArrowRightAlt } from '@material-ui/icons'
import i18n from 'i18next'
import moment from 'moment'
import { useUpdate } from '../reducer'
import { useDispatch, useSelector } from 'react-redux'
import { OFFER_LIMIT } from '../../pages/index'
import Link from 'next/link'
import { Post } from './Post'
import { Post as Post2 } from './Post2'

const postComponents = {
  trustme: Post,
  global: Post2
}

export const JobSection = ({ job, offers, truncate }) => {
  const update = useUpdate()

  const filters = useSelector((state) => state.filters.all || [])
  const siteSlug = useSelector((state) => state.site?.slug || 'global')

  const goToSectionHandler = (event) => {
    event.preventDefault()

    if (job.parent_job_id) {
      const newFilters = Array.from(new Set([...filters, `Job_${job.id}`]))
      update(['filters', 'all'], newFilters)
    } else {
      update(['filters', 'parentJobId'], job.id)
    }

    setTimeout(() => {
      location.href = '#search'
    }, 100)
  }

  const DynamicPostComponent = postComponents[Object.keys(postComponents).includes(siteSlug) ? siteSlug : 'global']

  return (
    <Fragment>
      <Box mb={5}>
        <Grid container>
          <Grid item container justifyContent="space-between">
            <Typography component="span" variant="h2" style={{ cursor: 'pointer', paddingBottom: '8px' }}>
              <Link href={`job/${job.hashid}`}>
                <a style={{ color: '#413E52', textDecoration: 'none' }} onClick={goToSectionHandler}>
                  {job.label}
                </a>
              </Link>
              {offers.length > OFFER_LIMIT && !truncate && <Fragment><ArrowRightAlt style={{ verticalAlign: 'bottom' }} /></Fragment>}
            </Typography>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          {offers.slice(0, truncate ? Infinity : OFFER_LIMIT).map((offer) => (
            <Grid xs={12} sm={6} item>
              <DynamicPostComponent offer={offer} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Fragment>
  )
}
